// 404 Not Found page

import React from 'react';
import { ArrowRight } from 'lucide-react';
import { Layout } from '../components/Layout';

export function NotFound() {
  return (
    <Layout>
      <div className="max-w-md mx-auto text-center mt-16">
        <div className="bg-card border border-border rounded-xl p-8">
          <h1 className="text-6xl font-bold text-muted-foreground/30 mb-4">404</h1>
          <h2 className="text-2xl font-bold mb-4 text-foreground">Page Not Found</h2>
          <p className="text-muted-foreground mb-6">
            The page you're looking for doesn't exist.
          </p>
          <a
            href="/"
            className="inline-flex items-center gap-2 bg-primary text-primary-foreground font-medium px-6 py-2.5 rounded-md hover:bg-primary/90 transition-all text-sm"
          >
            Back to Home
            <ArrowRight className="w-4 h-4" />
          </a>
        </div>
      </div>
    </Layout>
  );
}
